module.exports = __webpack_public_path__ + "img/esim.088f7801.png";